/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */


export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.webp");

export const GOLD_ICON = require('./res/images/gold.webp');
export const PLATINUM_ICON = require('./res/images/platinum-1.webp');
export const DIAMOND_ICON = require('./res/images/diamond.webp');
export const EMPTY_IMAGE = require("./res/images/empty.webp");




export const LIST_ASSET  =  require('./res/images/list-asset.png');
export const ANCHOR = require('./res/images/anchor.webp');



export const SOUND = require('./res/images/sound.png');
export const VIDEO = require('./res/images/default-video.png');
export const BANNER_IMAGE = require('./res/images/bg.webp');
export const VANTR_LOGO = require('./res/images/vantr-logo-blue-font.webp');
export const VANTR_WHITE_LOGO = require('./res/images/vantr-white.webp');

export const ETHER = require("./res/images/ether.webp");
export const MATIC = require("./res/images/matic.webp");



export const IMAGES = [
    VANTR_LOGO,
    VANTR_WHITE_LOGO,
    ORDINARY_DAY_IMAGE,
    GOLD_ICON,
    PLATINUM_ICON,
    DIAMOND_ICON,
    EMPTY_IMAGE,
    VIDEO,
    SOUND,
    ANCHOR,
    BANNER_IMAGE,
    MATIC,
    ETHER,
];
